export default {
  BASE_URL: '/admin/tged',
  api: [
    {
      name: 'list',
      desc: '获取申报列表',
      method: 'GET',
      path: '/activity/list'
    },
    {
      name: 'save',
      desc: '新增or保存申报',
      method: 'POST',
      path: '/activity/save'
    },
    {
      name: 'delete',
      desc: '删除申报',
      method: 'GET',
      path: '/activity/delete'
    },
    {
      name: 'enable',
      desc: '开启，关闭申报',
      method: 'GET',
      path: '/activity/manage'
    },
    {
      name: 'checkdecalreinfo',
      desc: '通过申报编号获取班组',
      method: 'GET',
      path: '/activity/checkdecalreinfo'
    },
    {
      name: 'backoff',
      desc: '退回申报',
      method: 'GET',
      path: '/activity/backoff'
    },
    {
      name: 'checkdetail',
      desc: '查看申报详情',
      method: 'GET',
      path: '/activity/checkdetail'
    },
    {
      name: 'teamgroupDetail',
      desc: '查看班组详情',
      method: 'GET',
      path: '/activity/checkdetail/teamgroup'
    },
    {
      name: 'decalreDetail',
      desc: '查看评价详情',
      method: 'GET',
      path: '/activity/checkdetail/decalre'
    },
    {
      name: 'loginfo',
      desc: '操作日志',
      method: 'GET',
      path: '/activity/listlog'
    },
    {
      name: 'getdeclarename',
      desc: '申报名称列表',
      method: 'GET',
      path: '/activity/getdeclarename'
    },
    {
      name: 'getenterprise',
      desc: '获取总承包施工企业下拉框数据',
      method: 'GET',
      path: '/teamgroup/getenterprise'
    },
    {
      name: 'getyearofdeclare',
      desc: '获取总承包施工企业下拉框数据',
      method: 'GET',
      path: '/teamgroup/getyearofdeclare'
    },
    {
      name: 'getstate',
      desc: '获取申报状态下拉数据',
      method: 'GET',
      path: '/teamgroup/getstate'
    },
    {
      name: 'listdeclarebycondition',
      desc: '申报列表查询按钮（按条件查询）',
      method: 'GET',
      path: '/activity/listdeclarebycondition'
    },
    {
      name: 'approved',
      desc: '申报审核通过',
      method: 'GET',
      path: '/activity/approved'
    },
    {
      name: 'checkdecalreinfo',
      desc: '通过申报编号获取班组',
      method: 'GET',
      path: '/activity/checkdecalreinfo'
    },
    {
      name: 'getadminrelateproject',
      desc: '获取关联工程项目下拉框数据',
      method: 'GET',
      path: '/teamgroup/getadminrelateproject'
    },
    {
      name: 'getteamgroupcode',
      desc: '获取班组名称(工种类型)下拉框数据',
      method: 'GET',
      path: '/teamgroup/getteamgroupcode'
    },
    {
      name: 'getteamgroupgrade',
      desc: '获取综合评价等级下拉框数据',
      method: 'GET',
      path: '/teamgroup/getteamgroupgrade'
    },
    {
      name: 'listteamgroupbycondition',
      desc: '申报列表查询班组按钮（按条件查询）',
      method: 'GET',
      path: '/activity/listteamgroupbycondition'
    },
    {
      name: 'exportDeclareinfo',
      desc: '班组资信评价汇总(导出)',
      method: 'POST',
      path: '/activity/export/declareinfo'
    },
  ]
}
  


// WEBPACK FOOTER //
// ./src/api/evaluation/index.js